import script from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\layout\\NavBar\\NavBar.vue?type=script"
export * from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\layout\\NavBar\\NavBar.vue?type=script"
export default script